import { SxProps } from '@mui/material';

export const shippingTitleGeneralSX: SxProps = {
	color: '#2C2C2C',
	fontSize: 'var(--font-size-md)',
	fontWeight: '800',
};

export const shippingTitleBookSX: SxProps = {
	color: '#2C2C2C',
	fontSize: 'var(--font-size-xl)',
	fontWeight: '800',
};

export const shippingTextContainterTypeSX: SxProps = {
	color: '#2C2C2C',
	fontSize: 'var(--font-size-default)',
	fontWeight: '600',
};
